import sharedStylesText from "./shared.css?inline";

/**
 * Singleton CSSStyleSheet containing shared styles (message bubbles, labels, scrollbars, etc.)
 * to be adopted by multiple components.
 */
export const sharedSheet = new CSSStyleSheet();
sharedSheet.replaceSync(sharedStylesText);
